/* assets/pg-promo-slider.js
   נוסף 25.7.2026 -- רוטציית משפטים בבאנר הפרומו העליון (עד 3 משפטים, לפי הגדרות
   התמה: promo_text / promo_text_2 / promo_text_3 תחת "Promotion in the header").
   ראו הערה מפורטת ב-snippets/promotion.liquid ובתיעוד השינויים (תיעוד-שינויים-עגלה-ובנדל.md).

   פועל רק אם יש יותר ממשפט אחד מלא (data-promo-messages מכיל מערך עם יותר מפריט
   אחד) -- אחרת לא עושה כלום, וההתנהגות/המראה הקיימים (משפט יחיד, סטטי, בדיוק
   כמו לפני התוספת הזו) נשארים ללא שינוי.

   אפקט: fade-out של הטקסט הנוכחי (opacity, מוגדר ב-CSS ב-assets/pg-slider.css),
   ואז מוחלף התוכן (innerHTML/href/target) ו-fade-in. רוטציה אוטומטית כל 4.5
   שניות + שני כפתורי חץ (prev/next) לניווט ידני שגם מאפסים את הטיימר האוטומטי
   כדי שלא "יריבו" עם לחיצה ידנית של המשתמש.

   עדכון 25.7.2026 (תיקון לפי משוב): כפתורי prev/next כבר לא עטופים יחד עם
   הטקסט ב-div אחד עם data-promo-slider (הוסר -- ראו promotion.liquid), אלא
   אחים ישירים שלו בתוך .promo. לכן החיפוש אחריהם עבר מ-closest('[data-promo-slider]')
   ל-closest('.promo'), וגם data-promo-autoplay עבר להיות מאפיין על ה-<a>
   עצמו (textEl) ולא על ה-wrapper שכבר לא קיים. */
(function () {
	function init() {
		var textEl = document.querySelector('.promo__text[data-promo-messages]');
		if (!textEl) return;

		var messages;
		try {
			messages = JSON.parse(textEl.getAttribute('data-promo-messages'));
		} catch (e) {
			return;
		}
		if (!messages || messages.length <= 1) return;

		var wrap = textEl.closest('.promo');
		var prevBtn = wrap ? wrap.querySelector('[data-promo-prev]') : null;
		var nextBtn = wrap ? wrap.querySelector('[data-promo-next]') : null;
		var autoplayMs = parseInt(textEl.getAttribute('data-promo-autoplay'), 10) || 4500;
		var fadeMs = 350;
		var current = 0;
		var timer = null;

		function render(index) {
			var m = messages[index];
			textEl.innerHTML = m.html;
			textEl.setAttribute('href', m.url || '#');
			if (m.target) {
				textEl.setAttribute('target', '_blank');
			} else {
				textEl.removeAttribute('target');
			}
		}

		function goTo(index) {
			current = ((index % messages.length) + messages.length) % messages.length;
			textEl.style.opacity = '0';
			window.setTimeout(function () {
				render(current);
				textEl.style.opacity = '1';
			}, fadeMs);
		}

		function next() {
			goTo(current + 1);
		}

		function prev() {
			goTo(current - 1);
		}

		function startAutoplay() {
			stopAutoplay();
			timer = window.setInterval(next, autoplayMs);
		}

		function stopAutoplay() {
			if (timer) {
				window.clearInterval(timer);
				timer = null;
			}
		}

		if (nextBtn) {
			nextBtn.addEventListener('click', function (e) {
				e.preventDefault();
				next();
				startAutoplay();
			});
		}
		if (prevBtn) {
			prevBtn.addEventListener('click', function (e) {
				e.preventDefault();
				prev();
				startAutoplay();
			});
		}

		startAutoplay();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
